<template>
  <div style="padding-bottom: 50px; padding-top: 20px">
    <el-row>
      <el-col class="main-left" :span="12">
        <el-form ref="busData" :model="busData" :rules="rules">
          <el-form-item prop="name" label="客户名称：" label-width="100px">
            <el-input v-model="busData.name" placeholder="客户名称"></el-input>

          </el-form-item>
          <el-form-item label-width="100px" label="英文名：" prop="EnglishName">
            <el-input v-model="busData.EnglishName" placeholder="英文名称"></el-input>

          </el-form-item>
          <el-form-item label-width="100px" label="地址：" prop="address">
            <el-input v-model="busData.address" placeholder="详细地址"></el-input>

          </el-form-item>
          <el-form-item label-width="100px" label="网址：">
            <el-input v-model="busData.website" placeholder="公司官网"></el-input>

          </el-form-item>
          <el-form-item label-width="100px" label="产品：">
            <el-input v-model="busData.productInfo" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea" placeholder="产品介绍"></el-input>

          </el-form-item>
          <el-form-item label-width="100px" label="简介：">
            <el-input v-model="busData.introduce" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea" placeholder="公司简介"></el-input>
          </el-form-item>

          <el-form-item label-width="100px" label="经营范围：">
            <el-input v-model="busData.businessScope" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea" placeholder="经营范围"></el-input>
          </el-form-item>

          <el-form-item label-width="100px" label="系统现状：">
            <el-cascader :props="system" :options="systemList" style="width: 500px"
                         :show-all-levels="false" placeholder="请选择" v-model="busData.integrateSystems"
                         clearable filterable/>
          </el-form-item>
          <el-form-item label-width="100px" label="已购套数：">
            <el-input-number v-model="busData.buyNumber" min="0" placeholder="已购套数"></el-input-number>
          </el-form-item>

          <el-form-item width="500px" label-width="100px" label="系统备注：">
            <el-input v-model="busData.systemRemark" placeholder="系统备注"></el-input>
          </el-form-item>

          <el-form-item label-width="100px" label="注册地：">
              <el-cascader  :props="props" v-model="busData.code" :options="catalogWithCity" style="width: 400px"
                           placeholder="选择地区" clearable filterable/>
          </el-form-item>

          <el-form ref="busData" :model="busData" :rules="rules" inline>
            <el-form-item label-width="100px" label="行业：" prop="industry">
              <el-select v-model="busData.industry" style="width:150px" placeholder="行业类型" clearable>
                <el-option v-for="item in industryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="100px" label="归属：" prop="belong">
              <el-checkbox v-model="busData.belong" style="margin-right: 40px;" label="卓盛客户"/>
            </el-form-item>
          </el-form>
          <el-form-item label-width="100px" label="轮播图：" prop="imageIds">
            <kf-image-upload limit="9" v-model:init-file="fileList" @fileChange="setImageId"></kf-image-upload>
          </el-form-item>
          <el-form-item label-width="100px" label="备注：">第一张添加图为案例展示首页展示图</el-form-item>
        </el-form>
      </el-col>
      <el-col class="main-right" style="margin-left: 20px;" :span="9">
        <el-form>
          <el-form-item label="关联案例：">
            <el-table stripe :data="tableData">
              <el-table-column align="center" prop="id" label="案例编号" width="150"/>
              <el-table-column align="center" prop="name" label="案例名称" width="400"/>
            </el-table>
          </el-form-item>
        </el-form>

      </el-col>
    </el-row>
    <el-button type="primary" style="width: 100px; margin-left: 50%;" @click="updateCustomer" :loading="loading">修改</el-button>
  </div>
</template>

<script>

import {Plus} from "@element-plus/icons-vue";

export default {
  name: "CaseUpdateCustomer",
  components: {Plus},
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },


  data() {
    return {
      fileList: [],
      catalogWithCity: [],
      industryList: [],
      tableData: [],
      systemList: [],
      loading: false,
      busData: {
        name: '',
        EnglishName: '',
        address: '',
        website: '',
        productInfo: '',
        introduce: '',
        businessScope: '',
        buyNumber: 0,
        systemRemark: '',
        integrateSystems: [],
        code: '',
        belong: false,
        industry: '',
        imageIds: [],

      },
      rules: {
        name: [{required: true, message: '请输入客户名称', trigger: 'blur'}],
        englishName: [{required: true, message: '请输入客户英文名称', trigger: 'blur'}],
        address: [{required: true, message: '请输入客户地址', trigger: 'blur'}],
        industry: [{required: true, message: '请选择行业', trigger: 'change'}],
        belong: [{required: true, message: '请输入客户归属', trigger: 'change'}],
        imageIds: [{required: true, message: '请加载客户主页图片', trigger: 'change'}],
      },
      props: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'value',
        label: 'label'
      },
      system: {
        emitPath:false,
        multiple: true,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      }

    }
  },
  created() {
    this.getCustomerWithDetail();
    this.getCity();
    this.getIndustryList();
    this.getCaseCntDetail();
    this.getSystemList();
  },

  methods: {
    //获取客户表单所有数据
    async getCustomerWithDetail() {
      let params = {customerId: this.parentData.id}
      this.busData = await this.$http('caseLibraryService.getCustomerDetailById', params)
      this.fileList = this.busData.fileList;
      for (let i = 0; i < this.fileList.length - 1; i++) {
        let file = this.fileList.get(i);
        this.busData.imageIds.add(file.id)
      }

    },
    //获取国内城市数据
    async getCity() {
      this.catalogWithCity = await this.$http('caseLibraryService.getCatalogCity')
    },
    //系统现状数据
    async getSystemList() {
      this.systemList = await this.$http('crmDsService.getCrmSoftwareTree')
    },
    //获取行业类型
    async getIndustryList() {
      this.industryList = await this.$http('caseLibraryService.getIndustryList')
    },

    //获取案例表格数据
    async getCaseCntDetail() {
      let params = {customerId: this.parentData.id}
      this.tableData = await this.$http('caseLibraryService.getCaseById', params)
    },
    //获取图片id
    setImageId(ids) {
      if (ids.length > 0) {
        this.busData.imageIds = ids
      }
    },
    //更新客户信息
    async updateCustomer() {
      this.$refs.busData.validate(async valid => {
        if (!valid) {
          return
        }
        this.loading = true;
        let params = {busData: this.busData, customerId: this.parentData.id}
        await this.$http('caseLibraryService.updateCustomerInfo', params).then(() => {
          this.loading = false;
          this.$fn.search();
          this.$fn.closeWindow();
          this.$message.success("修改成功");
        })
      })
    }

  }

}


</script>

<style scoped>

.close {
  position: absolute;
  top: 10px;
  right: 0px;
  font-size: 18px;
  cursor: pointer;
}

</style>